import updateApi from './api';
import updateUi from './ui';
import updateService from './service';
import updateUser from './user';
import updateDirectory from './directory';
import updateRoute from './route';
import updateGeozone from './geozone';


const reducer = (state, action) => {
  return {
    api:updateApi(state, action),             //самостоятельные результаты деятельности АПИ
    ui:updateUi(state, action),               //состояние интерфейса
    service:updateService(state, action),     //Сервисы
    user:updateUser(state, action),           //Пользователи
    directory:updateDirectory(state, action), //Справочники
    route:updateRoute(state, action),         //Маршруты
    geozone:updateGeozone(state, action),     //Геозоны
  }
}

export default reducer;
